"use client";

import { FC } from "react";

import { PortableTextProps } from "@portabletext/react";
import { PortableText } from "next-sanity";
import slugify from "react-slugify";

import { inlineSerializer } from "sanity-tools/lib/serializers/inline";

type PortableTextValue = PortableTextProps["value"];

interface CheckBoxProps {
  defaultChecked?: boolean;
  id?: string;
  label: string;
  labelContent?: PortableTextValue;
  required?: boolean;
}

const hasLabelContent = (
  value: PortableTextValue | undefined,
): value is NonNullable<PortableTextValue> =>
  Array.isArray(value) && value.length > 0;

export const CheckBox: FC<CheckBoxProps> = ({
  defaultChecked,
  id,
  label,
  labelContent,
  required = false,
}) => {
  const renderedId = id || slugify(label);
  const richLabel = hasLabelContent(labelContent) ? labelContent : null;

  return (
    <label
      className="flex flex-row items-center gap-4 text-base xl:text-xl"
      htmlFor={renderedId}
      key={renderedId}
    >
      <input
        className="size-8 focus-visible:outline focus-visible:outline-4 focus-visible:outline-darkerblue dark:focus-visible:outline-white"
        defaultChecked={defaultChecked}
        id={renderedId}
        name={renderedId}
        required={required}
        type="checkbox"
      />
      {richLabel ? (
        <PortableText components={inlineSerializer} value={richLabel} />
      ) : (
        label
      )}
    </label>
  );
};

export default CheckBox;
